import { render, staticRenderFns } from "./video-detail.vue?vue&type=template&id=ba626cfc&scoped=true&"
import script from "./video-detail.vue?vue&type=script&lang=js&"
export * from "./video-detail.vue?vue&type=script&lang=js&"
import style0 from "./video-detail.vue?vue&type=style&index=0&id=ba626cfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba626cfc",
  null
  
)

export default component.exports